module.exports = __webpack_public_path__ + "202408221624/img/pancel_1.b3ab4f90.png";